module.exports = __webpack_public_path__ + "static/media/blue_stress_EN.48944547.png";